import { CHAINS } from '@dapp/multi-lib/network';
import { TOKENS } from 'utils/constants/tokens';

export const NATIVE_TOKEN_ADDRESS =
  '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE' as const;

export const NATIVE_BNB_TOKEN = {
  symbol: 'BNB',
  name: 'BNB',
  address: NATIVE_TOKEN_ADDRESS,
  decimals: 18,
} as const;

export const NATIVE_ETH_TOKEN = {
  symbol: 'ETH',
  name: 'Ether',
  address: NATIVE_TOKEN_ADDRESS,
  decimals: 18,
} as const;

export const isNativeTokenAddress = (tokenAddress?: string) =>
  tokenAddress?.toLowerCase() === NATIVE_TOKEN_ADDRESS.toLowerCase();

export const isNativeBnbDeposit = (chainId: number, tokenAddress?: string) =>
  chainId === CHAINS.BSC_MAINNET && isNativeTokenAddress(tokenAddress);

export const isNativeDeposit = (chainId: number, tokenAddress?: string) =>
  (chainId === CHAINS.BSC_MAINNET ||
    chainId === CHAINS.ETH_MAINNET ||
    chainId === CHAINS.ARBITRUM_ONE ||
    chainId === CHAINS.BASE_L2) &&
  isNativeTokenAddress(tokenAddress);

export const getNativeDepositToken = (chainId: number) => {
  if (chainId === CHAINS.BSC_MAINNET) return NATIVE_BNB_TOKEN;
  if (
    chainId === CHAINS.ETH_MAINNET ||
    chainId === CHAINS.ARBITRUM_ONE ||
    chainId === CHAINS.BASE_L2
  ) {
    return NATIVE_ETH_TOKEN;
  }
  return undefined;
};

export const getDepositPriceTokenAddress = (
  chainId: number,
  tokenAddress: `0x${string}`
): `0x${string}` =>
  isNativeBnbDeposit(chainId, tokenAddress)
    ? TOKENS.BNB.WBNB.address
    : chainId === CHAINS.ETH_MAINNET && isNativeTokenAddress(tokenAddress)
      ? TOKENS.ETHEREUM.WETH.address
      : chainId === CHAINS.ARBITRUM_ONE && isNativeTokenAddress(tokenAddress)
        ? TOKENS.ARBITRUM.WETH.address
        : chainId === CHAINS.BASE_L2 && isNativeTokenAddress(tokenAddress)
          ? TOKENS.BASE_L2.WETH.address
          : tokenAddress;

interface NativePreviewParams {
  requester: `0x${string}`;
  tokenIn: `0x${string}`;
  amountIn: string;
  tokenOut: `0x${string}`;
}

export const getNativePreviewArgs = (params: NativePreviewParams) =>
  [
    params.requester,
    params.tokenIn,
    BigInt(params.amountIn),
    params.tokenOut,
  ] as const;

interface NativeSwapParams {
  tokenIn: `0x${string}`;
  amountIn: string;
  tokenOut: `0x${string}`;
  minAmountOut: string;
  receiver: `0x${string}`;
  swapData: readonly string[];
}

export const getNativeSwapParameters = (params: NativeSwapParams) => ({
  args: [
    params.tokenIn,
    BigInt(params.amountIn),
    params.tokenOut,
    BigInt(params.minAmountOut),
    params.receiver,
    params.swapData as readonly `0x${string}`[],
  ] as const,
  value: BigInt(params.amountIn),
});
